var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"feed-reviews-stats"},_vm.$listeners),[_c('base-icon',{staticClass:"feed-reviews-stats__icon mr-1",attrs:{"font-size":24}},[_vm._v("sci-comment-cloud")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }